// extracted by mini-css-extract-plugin
export default {"root":"TenantInfo_root__esC0-","center":"TenantInfo_center__PvEGK","main":"TenantInfo_main__i5Nzw"};